import { z } from 'zod';
import { PointSchema } from './Point.schema';

export const DiagramGroupSchema = z.object({
    label: z.string().default(''),
    position: PointSchema,
    width: z.number(),
    height: z.number(),
    borderStyle: z.string().nullable().default('1 0'),
    borderColor: z.string().nullable().default('black'),
    fillColor: z.string().nullable().default('none'),
    id: z.string(),
});
